// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"220":"2410a54f","339":"dbdf8d12","346":"ab82233d","575":"7de527b6","595":"9fd1c7e8","694":"3c5088a7"}[chunkId] + ".chunk.css";
};